import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { TopSliderComponent } from './views/home/top-slider/top-slider.component';
import { HomeComponent } from './views/home/hazmat-home/home.component';

// Slider

import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { ServicesBannerComponent } from './views/home/services-banner/services-banner.component';
import { TeamComponent } from './views/home/team/team.component';
import { NewComponent } from './views/home/new/new.component';
import { NovedadService } from './services/novedad.service';

import { HttpClientModule } from '@angular/common/http';
import { ContactUsComponent } from './views/home/contact-us/contact-us.component';
import { FooterComponent } from './components/footer/footer.component';
import { OurServicesComponent } from './views/our-services/our-services.component';
import { AboutUsComponent } from './views/about-us/about-us.component';
import { EquipmentComponent } from './equipment/equipment.component';

import { BasesComponent } from './bases/bases.component';
import { ContactComponent } from './contact/contact.component';
import { NewDetailComponent } from './new-detail/new-detail.component';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientsComponent } from './views/home/clients/clients.component';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { NewListComponent } from './new-list/new-list.component';

import { NgSelectModule } from '@ng-select/ng-select';
import { NewsletterComponent } from './views/home/newsletter/newsletter.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatExpansionModule } from '@angular/material/expansion';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    TopSliderComponent,
    HomeComponent,
    ServicesBannerComponent,
    TeamComponent,
    NewComponent,
    ContactUsComponent,
    FooterComponent,
    OurServicesComponent,
    AboutUsComponent,
    EquipmentComponent,
    BasesComponent,
    ContactComponent,
    NewDetailComponent,
    ClientsComponent,
    NewListComponent,
    NewsletterComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SwiperModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    FilterPipeModule,
    NgSelectModule,
    MatExpansionModule,
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG,
    },
    NovedadService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
